(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[67973],{

/***/ 874:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.x = function FaWhatsapp (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 448 512"},"child":[{"tag":"path","attr":{"d":"M380.9 97.1C339 55.1 283.2 32 223.9 32c-122.4 0-222 99.6-222 222 0 39.1 10.2 77.3 29.6 111L0 480l117.7-30.9c32.4 17.7 68.9 27 106.1 27h.1c122.3 0 224.1-99.6 224.1-222 0-59.3-25.2-115-67.1-157zm-157 341.6c-33.2 0-65.7-8.9-94-25.7l-6.7-4-69.8 18.3L72 359.2l-4.4-7c-18.5-29.4-28.2-63.3-28.2-98.2 0-101.7 82.8-184.5 184.6-184.5 49.3 0 95.6 19.2 130.4 54.1 34.8 34.9 56.2 81.2 56.1 130.5 0 101.8-84.9 184.6-186.6 184.6zm101.2-138.2c-5.5-2.8-32.8-16.2-37.9-18-5.1-1.9-8.8-2.8-12.5 2.8-3.7 5.6-14.3 18-17.6 21.8-3.2 3.7-6.5 4.2-12 1.4-32.6-16.3-54-29.1-75.5-66-5.7-9.8 5.7-9.1 16.3-30.3 1.8-3.7.9-6.9-.5-9.7-1.4-2.8-12.5-30.1-17.1-41.2-4.5-10.8-9.1-9.3-12.5-9.5-3.2-.2-6.9-.2-10.6-.2-3.7 0-9.7 1.4-14.8 6.9-5.1 5.6-19.4 19-19.4 46.3 0 27.3 19.9 53.7 22.6 57.4 2.8 3.7 39.1 59.7 94.8 83.8 35.2 15.2 49 16.5 66.6 13.9 10.7-1.6 32.8-13.4 37.4-26.4 4.6-13 4.6-24.1 3.2-26.4-1.3-2.5-5-3.9-10.5-6.6z"}}]})(props);
};


/***/ }),

/***/ 92486:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports._ = function FiCheckCircle (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M22 11.08V12a10 10 0 1 1-5.93-9.14"}},{"tag":"polyline","attr":{"points":"22 4 12 14.01 9 11.01"}}]})(props);
};


/***/ }),

/***/ 12422:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports._ = function FiDownload (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"}},{"tag":"polyline","attr":{"points":"7 10 12 15 17 10"}},{"tag":"line","attr":{"x1":"12","y1":"15","x2":"12","y2":"3"}}]})(props);
};


/***/ }),

/***/ 51127:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.Y = function FiDroplet (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M12 2.69l5.66 5.66a8 8 0 1 1-11.31 0z"}}]})(props);
};


/***/ }),

/***/ 64311:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.N = function FiFileText (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"}},{"tag":"polyline","attr":{"points":"14 2 14 8 20 8"}},{"tag":"line","attr":{"x1":"16","y1":"13","x2":"8","y2":"13"}},{"tag":"line","attr":{"x1":"16","y1":"17","x2":"8","y2":"17"}},{"tag":"polyline","attr":{"points":"10 9 9 9 8 9"}}]})(props);
};


/***/ }),

/***/ 85136:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.m = function FiHome (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"}},{"tag":"polyline","attr":{"points":"9 22 9 12 15 12 15 22"}}]})(props);
};


/***/ }),

/***/ 56998:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.I = function FiMail (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"}},{"tag":"polyline","attr":{"points":"22,6 12,13 2,6"}}]})(props);
};


/***/ }),

/***/ 46159:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.i = function FiMapPin (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"}},{"tag":"circle","attr":{"cx":"12","cy":"10","r":"3"}}]})(props);
};


/***/ }),

/***/ 61179:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.D = function FiMaximize2 (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"polyline","attr":{"points":"15 3 21 3 21 9"}},{"tag":"polyline","attr":{"points":"9 21 3 21 3 15"}},{"tag":"line","attr":{"x1":"21","y1":"3","x2":"14","y2":"10"}},{"tag":"line","attr":{"x1":"3","y1":"21","x2":"10","y2":"14"}}]})(props);
};


/***/ }),

/***/ 51809:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.t = function FiPhone (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"path","attr":{"d":"M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"}}]})(props);
};


/***/ }),

/***/ 38468:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

// THIS FILE IS AUTO GENERATED
var GenIcon = (__webpack_require__(15787)/* .GenIcon */ .w_)
module.exports.k = function FiSun (props) {
  return GenIcon({"tag":"svg","attr":{"viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round"},"child":[{"tag":"circle","attr":{"cx":"12","cy":"12","r":"5"}},{"tag":"line","attr":{"x1":"12","y1":"1","x2":"12","y2":"3"}},{"tag":"line","attr":{"x1":"12","y1":"21","x2":"12","y2":"23"}},{"tag":"line","attr":{"x1":"4.22","y1":"4.22","x2":"5.64","y2":"5.64"}},{"tag":"line","attr":{"x1":"18.36","y1":"18.36","x2":"19.78","y2":"19.78"}},{"tag":"line","attr":{"x1":"1","y1":"12","x2":"3","y2":"12"}},{"tag":"line","attr":{"x1":"21","y1":"12","x2":"23","y2":"12"}},{"tag":"line","attr":{"x1":"4.22","y1":"19.78","x2":"5.64","y2":"18.36"}},{"tag":"line","attr":{"x1":"18.36","y1":"5.64","x2":"19.78","y2":"4.22"}}]})(props);
};


/***/ }),

/***/ 15787:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "w_": function() { return /* reexport */ GenIcon; }
});

// UNUSED EXPORTS: DefaultContext, IconBase, IconContext, IconsManifest

;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconsManifest.js
var IconsManifest = [
  {
    "id": "fa",
    "name": "Font Awesome",
    "projectUrl": "https://fontawesome.com/",
    "license": "CC BY 4.0 License",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  },
  {
    "id": "io",
    "name": "Ionicons 4",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "io5",
    "name": "Ionicons 5",
    "projectUrl": "https://ionicons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/ionic-team/ionicons/blob/master/LICENSE"
  },
  {
    "id": "md",
    "name": "Material Design icons",
    "projectUrl": "http://google.github.io/material-design-icons/",
    "license": "Apache License Version 2.0",
    "licenseUrl": "https://github.com/google/material-design-icons/blob/master/LICENSE"
  },
  {
    "id": "ti",
    "name": "Typicons",
    "projectUrl": "http://s-ings.com/typicons/",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0/"
  },
  {
    "id": "go",
    "name": "Github Octicons icons",
    "projectUrl": "https://octicons.github.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/primer/octicons/blob/master/LICENSE"
  },
  {
    "id": "fi",
    "name": "Feather",
    "projectUrl": "https://feathericons.com/",
    "license": "MIT",
    "licenseUrl": "https://github.com/feathericons/feather/blob/master/LICENSE"
  },
  {
    "id": "gi",
    "name": "Game Icons",
    "projectUrl": "https://game-icons.net/",
    "license": "CC BY 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/3.0/"
  },
  {
    "id": "wi",
    "name": "Weather Icons",
    "projectUrl": "https://erikflowers.github.io/weather-icons/",
    "license": "SIL OFL 1.1",
    "licenseUrl": "http://scripts.sil.org/OFL"
  },
  {
    "id": "di",
    "name": "Devicons",
    "projectUrl": "https://vorillaz.github.io/devicons/",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ai",
    "name": "Ant Design Icons",
    "projectUrl": "https://github.com/ant-design/ant-design-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "bs",
    "name": "Bootstrap Icons",
    "projectUrl": "https://github.com/twbs/icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "ri",
    "name": "Remix Icon",
    "projectUrl": "https://github.com/Remix-Design/RemixIcon",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "fc",
    "name": "Flat Color Icons",
    "projectUrl": "https://github.com/icons8/flat-color-icons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "gr",
    "name": "Grommet-Icons",
    "projectUrl": "https://github.com/grommet/grommet-icons",
    "license": "Apache License Version 2.0",
    "licenseUrl": "http://www.apache.org/licenses/"
  },
  {
    "id": "hi",
    "name": "Heroicons",
    "projectUrl": "https://github.com/refactoringui/heroicons",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "si",
    "name": "Simple Icons",
    "projectUrl": "https://simpleicons.org/",
    "license": "CC0 1.0 Universal",
    "licenseUrl": "https://creativecommons.org/publicdomain/zero/1.0/"
  },
  {
    "id": "im",
    "name": "IcoMoon Free",
    "projectUrl": "https://github.com/Keyamoon/IcoMoon-Free",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "bi",
    "name": "BoxIcons",
    "projectUrl": "https://github.com/atisawd/boxicons",
    "license": "CC BY 4.0 License"
  },
  {
    "id": "cg",
    "name": "css.gg",
    "projectUrl": "https://github.com/astrit/css.gg",
    "license": "MIT",
    "licenseUrl": "https://opensource.org/licenses/MIT"
  },
  {
    "id": "vsc",
    "name": "VS Code Icons",
    "projectUrl": "https://github.com/microsoft/vscode-codicons",
    "license": "CC BY 4.0",
    "licenseUrl": "https://creativecommons.org/licenses/by/4.0/"
  }
]
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconContext.js

var DefaultContext = {
  color: undefined,
  size: undefined,
  className: undefined,
  style: undefined,
  attr: undefined
};
var IconContext = react.createContext && react.createContext(DefaultContext);
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/iconBase.js
var __assign = undefined && undefined.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = undefined && undefined.__rest || function (s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};




function Tree2Element(tree) {
  return tree && tree.map(function (node, i) {
    return react.createElement(node.tag, __assign({
      key: i
    }, node.attr), Tree2Element(node.child));
  });
}

function GenIcon(data) {
  return function (props) {
    return react.createElement(IconBase, __assign({
      attr: __assign({}, data.attr)
    }, props), Tree2Element(data.child));
  };
}
function IconBase(props) {
  var elem = function (conf) {
    var attr = props.attr,
        size = props.size,
        title = props.title,
        svgProps = __rest(props, ["attr", "size", "title"]);

    var computedSize = size || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props.className) className = (className ? className + ' ' : '') + props.className;
    return react.createElement("svg", __assign({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className: className,
      style: __assign(__assign({
        color: props.color || conf.color
      }, conf.style), props.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && react.createElement("title", null, title), props.children);
  };

  return IconContext !== undefined ? react.createElement(IconContext.Consumer, null, function (conf) {
    return elem(conf);
  }) : elem(DefaultContext);
}
;// CONCATENATED MODULE: ./node_modules/@react-icons/all-files/lib/esm/index.js




/***/ }),

/***/ 21360:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/satilik-villa",
      function () {
        return __webpack_require__(66984);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 48007:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ components_Layout; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/react-toastify/dist/react-toastify.esm.mjs + 1 modules
var react_toastify_esm = __webpack_require__(22920);
// EXTERNAL MODULE: ./context/context.js
var context = __webpack_require__(94268);
;// CONCATENATED MODULE: ./components/Backdrop.js



var Backdrop = function() {
    var ref = (0,react.useContext)(context/* StoreContext */.x), backdrop = ref.backdrop, setBackdrop = ref.setBackdrop;
    if (backdrop) return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "fixed z-50 bg-black bg-opacity-70 w-screen inset-0 h-screen ",
        onClick: function() {
            setBackdrop(false);
        }
    });
};
/* harmony default export */ var components_Backdrop = (Backdrop);

// EXTERNAL MODULE: ./context/TranslationContext.js
var TranslationContext = __webpack_require__(73040);
;// CONCATENATED MODULE: ./components/FavouritesRight.js





var FavouritesList = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 88926).then(__webpack_require__.bind(__webpack_require__, 88926));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88926)
            ];
        }
    },
    ssr: false
});
var FavouritesRight = function() {
    var Close = function Close() {
        setFavouritesIsOpen(0);
    };
    var favouritesRightTitle = (0,TranslationContext/* useTranslation */.m)().favouritesRightTitle;
    var ref = (0,react.useContext)(context/* StoreContext */.x), setFavouritesIsOpen = ref.setFavouritesIsOpen, favouritesIsOpen = ref.favouritesIsOpen;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "fixed  flex-col flex right-0 top-0 bg-white shadow-lg w-72 rounded-sm h-screen px-3 py-5 overflow-y-auto z-50 transition-all transform-gpu " + (favouritesIsOpen ? "translate-x-0 " : "translate-x-full "),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex justify-between items-center mb-3 ",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                        className: "text-lg inline-block",
                        children: favouritesRightTitle
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("button", {
                        onClick: function(e) {
                            Close();
                        },
                        children: "x"
                    })
                ]
            }),
            favouritesIsOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(FavouritesList, {}) : null
        ]
    });
};
/* harmony default export */ var components_FavouritesRight = (FavouritesRight);

// EXTERNAL MODULE: ./node_modules/is-mobile/index.js
var is_mobile = __webpack_require__(63805);
var is_mobile_default = /*#__PURE__*/__webpack_require__.n(is_mobile);
;// CONCATENATED MODULE: ./components/Layout.js








var Menubar = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 11977).then(__webpack_require__.bind(__webpack_require__, 11977));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11977)
            ];
        }
    },
    ssr: false
});
var WhatsappDesktop = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(75617)]).then(__webpack_require__.bind(__webpack_require__, 80039));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80039)
            ];
        }
    },
    ssr: false
});
var Footer = dynamic_default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(63755), __webpack_require__.e(9012), __webpack_require__.e(31985)]).then(__webpack_require__.bind(__webpack_require__, 58114));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(58114)
            ];
        }
    }
});
var Layout = function(param) {
    var ssr = param.ssr, children = param.children, isAppWebView = param.isAppWebView, deviceType = param.deviceType;
    var ref = (0,react.useState)(false), isPhone = ref[0], setIsPhone = ref[1];
    var ref1 = (0,react.useContext)(context/* StoreContext */.x) || {}, setPage = ref1.setPage, setCurrentRoutingTypeId = ref1.setCurrentRoutingTypeId, currentRoutingTypeId = ref1.currentRoutingTypeId;
    (0,react.useEffect)(function() {
        setIsPhone(is_mobile_default()());
    }, []);
    (0,react.useEffect)(function() {
        setCurrentRoutingTypeId(ssr.RoutingTypeId);
        setPage(ssr.result);
    }, [
        ssr
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            children,
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_Backdrop, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_toastify_esm/* ToastContainer */.Ix, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FavouritesRight, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Menubar, {
                ssr: ssr.result,
                RoutingTypeId: ssr.RoutingTypeId,
                isAppWebView: isAppWebView,
                deviceType: deviceType
            }),
            !isPhone ? /*#__PURE__*/ (0,jsx_runtime.jsx)(WhatsappDesktop, {}) : null,
            ssr.result.footer != "0" && ssr.disableHeader != true && /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                ssr: ssr
            })
        ]
    });
};
/* harmony default export */ var components_Layout = (Layout);


/***/ }),

/***/ 66984:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ SatilikVilla; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(48007);
/* harmony import */ var swiper_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30719);
/* harmony import */ var swiper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88116);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(30933);
/* harmony import */ var swiper_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(swiper_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(92);
/* harmony import */ var swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(swiper_css_navigation__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(68770);
/* harmony import */ var swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(swiper_css_pagination__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9846);
/* harmony import */ var swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(swiper_css_effect_fade__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _react_icons_all_files_fi_FiMaximize2__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(61179);
/* harmony import */ var _react_icons_all_files_fi_FiMapPin__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(46159);
/* harmony import */ var _react_icons_all_files_fi_FiCheckCircle__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(92486);
/* harmony import */ var _react_icons_all_files_fi_FiPhone__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(51809);
/* harmony import */ var _react_icons_all_files_fi_FiMail__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(56998);
/* harmony import */ var _react_icons_all_files_fi_FiHome__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(85136);
/* harmony import */ var _react_icons_all_files_fi_FiDroplet__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(51127);
/* harmony import */ var _react_icons_all_files_fi_FiSun__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(38468);
/* harmony import */ var _react_icons_all_files_fi_FiDownload__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(12422);
/* harmony import */ var _react_icons_all_files_fi_FiFileText__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(64311);
/* harmony import */ var _react_icons_all_files_fa_FaWhatsapp__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(874);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_10__);
























var Fancybox = next_dynamic__WEBPACK_IMPORTED_MODULE_10___default()(function() {
    return __webpack_require__.e(/* import() */ 92235).then(__webpack_require__.bind(__webpack_require__, 92235));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(92235)
            ];
        }
    },
    ssr: false
});
// Dinamik olarak galeri resimlerini oluşturuyoruz (resized klasörü kullanılarak)
var galleryImages = [
    "https://cdn.villavillam.com.tr/lujo-emo-villas/galeri/resized/lujo_emo_fethiye.jpg"
].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)(Array.from({
    length: 60
}, function(_, i) {
    return "https://cdn.villavillam.com.tr/lujo-emo-villas/galeri/resized/lujo_emo_fethiye%20(".concat(i + 2, ").jpg");
})));
// Hero arka planı olarak Drone/Dış Cephe fotoğrafı (1. resim)
var heroImage = galleryImages[0];
// İletişim arka planı olarak farklı bir dış cephe fotoğrafı (örneğin 5. resim)
var ctaImage = galleryImages[4] || galleryImages[1];
// Video posteri olarak iç mekan veya havuz (örneğin 10. resim)
var videoPoster = galleryImages[9] || galleryImages[2];
var features = [
    "4+1 Oda Se\xe7ene\u011Fi",
    "500 m\xb2 Arsa Pay\u0131",
    "372 m\xb2 Kullan\u0131m Alan\u0131",
    "Yerden Is\u0131tma Sistemi",
    "Multi Klima Sistem",
    "Boyler G\xfcne\u015F Enerjisi",
    "Su Yumu\u015Fat\u0131c\u0131 Sistem",
    "Do\u011Fal Mermer/Traverten",
    "Hamam, Sauna, Kapal\u0131 Havuz",
    "M\xfcstakil D\u0131\u015F Havuz (50 m\xb2)"
];
var floorPlans = [
    {
        id: "vaziyet",
        name: "Vaziyet Plan\u0131",
        url: "https://cdn.villavillam.com.tr/lujo-emo-villas/kat-planlari/lujo-emo-vaziyet-plan.pdf"
    },
    {
        id: "bodrum",
        name: "Bodrum Kat",
        url: "https://cdn.villavillam.com.tr/lujo-emo-villas/kat-planlari/lujo-emo-bodrum-kat-plan.pdf"
    },
    {
        id: "zemin",
        name: "Zemin Kat",
        url: "https://cdn.villavillam.com.tr/lujo-emo-villas/kat-planlari/lujo-emo-zemin-kat-plan.pdf"
    },
    {
        id: "birinci",
        name: "1. Kat",
        url: "https://cdn.villavillam.com.tr/lujo-emo-villas/kat-planlari/lujo-emo-1-kat-plan.pdf"
    },
    {
        id: "cati",
        name: "\xc7at\u0131 Kat\u0131",
        url: "https://cdn.villavillam.com.tr/lujo-emo-villas/kat-planlari/lujo-emo-cati-kat-plan.pdf"
    }
];
var __N_SSG = true;
function SatilikVilla(param) {
    var data = param.data;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), hoveredLoc = ref[0], setHoveredLoc = ref[1];
    var mapIframeRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var mainSwiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var thumbsSwiperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var handleSlideChange = function(swiper) {
        var thumbs = thumbsSwiperRef.current;
        if (!thumbs || thumbs.destroyed) return;
        var slides = thumbs.slides;
        if (!slides) return;
        for(var i = 0; i < slides.length; i++){
            if (i === swiper.activeIndex) {
                slides[i].classList.add("opacity-100", "border-brand-color-primary");
                slides[i].classList.remove("opacity-50", "border-transparent");
            } else {
                slides[i].classList.remove("opacity-100", "border-brand-color-primary");
                slides[i].classList.add("opacity-50", "border-transparent");
            }
        }
        // Also scroll thumbs swiper to active slide if needed
        thumbs.slideTo(swiper.activeIndex);
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (mapIframeRef.current && mapIframeRef.current.contentWindow) {
            mapIframeRef.current.contentWindow.postMessage({
                type: "HOVER_LOC",
                id: hoveredLoc
            }, "*");
        }
    }, [
        hoveredLoc
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        ssr: data,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                        children: "Lujo Emo Villas Fethiye - Lansmana \xd6zel Sat\u0131l\u0131k Villalar"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        name: "description",
                        content: "Lujo Emo Villas Fethiye projemizde yer alan s\u0131n\u0131rl\u0131 say\u0131daki premium sat\u0131l\u0131k villalar\u0131m\u0131z\u0131 inceleyin."
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("main", {
                className: "relative z-0 w-full bg-slate-50 min-h-screen font-sans",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "relative w-full h-[65vh] md:h-[85vh] lg:h-screen flex items-center justify-center overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute top-0 right-0 z-40 w-36 h-36 md:w-48 md:h-48 overflow-hidden pointer-events-none",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "absolute top-8 -right-8 w-48 md:top-12 md:-right-12 md:w-64 text-white text-center py-1 md:py-2 font-bold text-[9px] md:text-sm uppercase tracking-[0.1em] md:tracking-[0.2em] shadow-xl transform rotate-45 border-y border-white/20",
                                    style: {
                                        backgroundColor: "#f26c22"
                                    },
                                    children: "HEMEN TESL\u0130M !"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "absolute inset-0 z-0",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                                    modules: [
                                        swiper__WEBPACK_IMPORTED_MODULE_5__/* .Autoplay */ .pt,
                                        swiper__WEBPACK_IMPORTED_MODULE_5__/* .EffectFade */ .xW
                                    ],
                                    effect: "fade",
                                    autoplay: {
                                        delay: 5000,
                                        disableOnInteraction: false
                                    },
                                    allowTouchMove: false,
                                    className: "w-full h-full",
                                    children: [
                                        galleryImages[0],
                                        galleryImages[4],
                                        galleryImages[2]
                                    ].map(function(src, index) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                    src: src,
                                                    alt: "Lujo Emo Villas Fethiye - ".concat(index + 1),
                                                    className: "w-full h-full object-cover scale-105 transform origin-center",
                                                    style: {
                                                        animation: "scaleUp 20s ease-out infinite alternate"
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "absolute inset-0 bg-gradient-to-b from-black/60 via-black/30 to-black/80"
                                                })
                                            ]
                                        }, index);
                                    })
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative z-10 text-center px-4 max-w-4xl mx-auto mt-4 md:mt-20",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "inline-block py-1 px-3 border border-white/40 backdrop-blur-md rounded-full text-white/90 text-xs md:text-sm tracking-[0.2em] uppercase mb-4 md:mb-6",
                                        children: "S\u0131n\u0131rl\u0131 \xdcretim \u2022 Sadece 5 Adet"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h1", {
                                        className: "text-4xl md:text-6xl lg:text-7xl font-light text-white tracking-tight mb-4 md:mb-6 drop-shadow-lg",
                                        children: [
                                            "Lujo Emo Villas ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "font-bold",
                                                children: "Fethiye"
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-base md:text-xl text-white/90 font-light mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed drop-shadow",
                                        children: "Modern mimarinin do\u011Fa ile kusursuz uyumu. Ya\u015Fam standartlar\u0131n\u0131z\u0131 yeniden tan\u0131mlayacak elit bir proje."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                href: "#iletisim",
                                                className: "inline-block bg-white text-black px-6 py-3 md:px-8 md:py-4 rounded-full font-medium tracking-wide hover:bg-brand-color-primary hover:text-white transition-colors duration-300 shadow-xl text-sm md:text-base",
                                                children: "Hemen Bilgi Al\u0131n"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                href: "https://cdn.villavillam.com.tr/lujo-emo-villas/katalog.pdf",
                                                target: "_blank",
                                                rel: "noopener noreferrer",
                                                className: "inline-flex items-center justify-center gap-2 bg-transparent border-2 border-white text-white px-6 py-3 md:px-8 md:py-4 rounded-full font-medium tracking-wide hover:bg-white hover:text-black transition-colors duration-300 shadow-xl text-sm md:text-base",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiDownload__WEBPACK_IMPORTED_MODULE_12__/* .FiDownload */ ._, {}),
                                                    " Katalo\u011Fu \u0130ndir"
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "absolute bottom-4 md:bottom-10 left-1/2 transform -translate-x-1/2 z-10 hidden sm:flex flex-col items-center animate-bounce",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: "text-white/70 text-xs tracking-widest uppercase mb-2",
                                        children: "Ke\u015Ffet"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-[1px] h-12 bg-gradient-to-b from-white/70 to-transparent"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "relative z-20 -mt-10 md:-mt-16 mx-4 md:mx-auto max-w-5xl bg-white/95 backdrop-blur-2xl rounded-2xl md:rounded-3xl shadow-[0_20px_50px_rgba(0,0,0,0.1)] p-5 md:p-8 border border-white/60",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "grid grid-cols-2 md:grid-cols-4 gap-y-6 gap-x-4 md:gap-8 text-center divide-x divide-gray-100/50",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "p-1 md:p-2 group",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-brand-color-primary text-3xl md:text-4xl mb-2 md:mb-4 flex justify-center transform group-hover:scale-110 transition-transform duration-300",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiHome__WEBPACK_IMPORTED_MODULE_13__/* .FiHome */ .m, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-900 font-bold text-xl md:text-2xl tracking-tight",
                                            children: "4+1"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-500 text-[10px] md:text-xs font-semibold tracking-[0.1em] md:tracking-[0.2em] uppercase mt-1 md:mt-2",
                                            children: "Geni\u015F Odalar"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "p-1 md:p-2 group",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-brand-color-primary text-3xl md:text-4xl mb-2 md:mb-4 flex justify-center transform group-hover:scale-110 transition-transform duration-300",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiMaximize2__WEBPACK_IMPORTED_MODULE_14__/* .FiMaximize2 */ .D, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-900 font-bold text-xl md:text-2xl tracking-tight",
                                            children: "Premium"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-500 text-[10px] md:text-xs font-semibold tracking-[0.1em] md:tracking-[0.2em] uppercase mt-1 md:mt-2",
                                            children: "Ya\u015Fam Alan\u0131"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "p-1 md:p-2 group",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-brand-color-primary text-3xl md:text-4xl mb-2 md:mb-4 flex justify-center transform group-hover:scale-110 transition-transform duration-300",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiDroplet__WEBPACK_IMPORTED_MODULE_15__/* .FiDroplet */ .Y, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-900 font-bold text-xl md:text-2xl tracking-tight",
                                            children: "M\xfcstakil"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-500 text-[10px] md:text-xs font-semibold tracking-[0.1em] md:tracking-[0.2em] uppercase mt-1 md:mt-2",
                                            children: "Y\xfczme Havuzu"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "p-1 md:p-2 group border-l-0 md:border-l",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-brand-color-primary text-3xl md:text-4xl mb-2 md:mb-4 flex justify-center transform group-hover:scale-110 transition-transform duration-300",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiSun__WEBPACK_IMPORTED_MODULE_16__/* .FiSun */ .k, {})
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-900 font-bold text-xl md:text-2xl tracking-tight",
                                            children: "Fethiye"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "block text-gray-500 text-[10px] md:text-xs font-semibold tracking-[0.1em] md:tracking-[0.2em] uppercase mt-1 md:mt-2",
                                            children: "E\u015Fsiz Konum"
                                        })
                                    ]
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "py-24 px-6 max-w-6xl mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col md:flex-row items-stretch gap-16",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full md:w-1/2 flex flex-col justify-center",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex items-center gap-4 mb-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: "w-12 h-[2px] bg-brand-color-primary"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                    className: "text-xs font-bold text-brand-color-primary uppercase tracking-[0.3em]",
                                                    children: "Projeye Dair"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h3", {
                                            className: "text-4xl md:text-5xl font-light text-gray-900 mb-8 leading-tight tracking-tight",
                                            children: [
                                                "Do\u011Fa ile ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("br", {}),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "font-bold text-brand-color-primary tracking-normal block md:inline mt-2 md:mt-0",
                                                    children: "Ortak Notan\u0131z !"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 text-lg leading-relaxed mb-6 font-light",
                                            children: "Her an\u0131nda do\u011Fan\u0131n ve konforun tad\u0131n\u0131 \xe7\u0131karabilece\u011Finiz bu villalar, \xf6zellikle Babada\u011F'\u0131n muhte\u015Fem manzaras\u0131yla \xf6ne \xe7\u0131k\u0131yor. Sabah kahvenizi i\xe7erken g\xfcn\xfcn ilk \u0131\u015F\u0131klar\u0131 Babada\u011F'\u0131n zirvesinden yans\u0131rken, ak\u015Fam g\xfcne\u015Fi muazzam manzarayla vedala\u015F\u0131yor. Bu e\u015Fsiz atmosferde \xf6zel bir hikaye yazma f\u0131rsat\u0131n\u0131 sunuyor."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-500 leading-relaxed mb-8",
                                            children: "G\xfcnl\xfck hayat\u0131n stres ve rutininden k\u0131\u015F aylar\u0131nda da ka\xe7abilmeniz i\xe7in hamam, sauna, kapal\u0131 havuz ve bar alan\u0131yla tatil konforunuzu yuvan\u0131zda ya\u015Fay\u0131n. Geni\u015F ve ferah salonu ile i\u015Flevselli\u011Fin \xf6n plana al\u0131nd\u0131\u011F\u0131 mutfa\u011F\u0131 konforu yeniden tan\u0131ml\u0131yor. B\xf6lgenin e\u015Fsiz do\u011Fas\u0131na naz\u0131r, her k\xf6\u015Fesi l\xfcks ve konfor detaylar\u0131yla dikkat \xe7eken yemye\u015Fil bir bah\xe7e alan\u0131."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "mt-auto pt-6 w-full max-w-full overflow-hidden",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Fancybox, {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "block md:hidden w-full",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                                                                modules: [
                                                                    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_,
                                                                    swiper__WEBPACK_IMPORTED_MODULE_5__/* .Autoplay */ .pt
                                                                ],
                                                                spaceBetween: 10,
                                                                navigation: true,
                                                                onSwiper: function(swiper) {
                                                                    mainSwiperRef.current = swiper;
                                                                },
                                                                onSlideChange: handleSlideChange,
                                                                autoplay: {
                                                                    delay: 3500,
                                                                    disableOnInteraction: false
                                                                },
                                                                className: "w-full aspect-[4/3] rounded-xl overflow-hidden mb-3 shadow-md",
                                                                children: galleryImages.slice(0, 10).map(function(src, idx) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                            href: src,
                                                                            "data-fancybox": "mobile-gallery",
                                                                            className: "w-full h-full block cursor-zoom-in relative",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                    src: src,
                                                                                    className: "w-full h-full object-cover"
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                    className: "absolute top-3 right-3 bg-black/50 text-white rounded-full p-2 backdrop-blur-sm",
                                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                                        className: "w-5 h-5",
                                                                                        fill: "none",
                                                                                        stroke: "currentColor",
                                                                                        viewBox: "0 0 24 24",
                                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                                            strokeLinecap: "round",
                                                                                            strokeLinejoin: "round",
                                                                                            strokeWidth: "2",
                                                                                            d: "M4 8V4m0 0h4M4 4l5 5m11-1V4m0 0h-4m4 0l-5 5M4 16v4m0 0h4m-4 0l5-5m11 5l-5-5m5 5v-4m0 4h-4"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            ]
                                                                        })
                                                                    }, idx);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                                                                onSwiper: function(swiper) {
                                                                    thumbsSwiperRef.current = swiper;
                                                                },
                                                                spaceBetween: 10,
                                                                slidesPerView: 4.5,
                                                                className: "w-full h-16",
                                                                children: galleryImages.slice(0, 10).map(function(src, idx) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                                                        onClick: function() {
                                                                            return mainSwiperRef.current && mainSwiperRef.current.slideTo(idx);
                                                                        },
                                                                        className: "cursor-pointer transition-all border-2 rounded-lg overflow-hidden shrink-0 ".concat(idx === 0 ? "opacity-100 border-brand-color-primary" : "opacity-50 border-transparent"),
                                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: src,
                                                                            className: "w-full h-full object-cover"
                                                                        })
                                                                    }, idx);
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                href: galleryImages[10],
                                                                "data-fancybox": "mobile-gallery",
                                                                className: "mt-4 w-full bg-slate-50 text-brand-color-primary font-bold py-3 px-4 rounded-xl flex items-center justify-between border border-gray-200 shadow-sm",
                                                                children: [
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                        children: "T\xfcm Foto\u011Fraflar\u0131 G\xf6r"
                                                                    }),
                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                        className: "bg-brand-color-primary/10 px-3 py-1 rounded-lg text-sm",
                                                                        children: [
                                                                            "+",
                                                                            galleryImages.length - 10,
                                                                            " Foto\u011Fraf"
                                                                        ]
                                                                    })
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "hidden",
                                                                children: galleryImages.slice(11).map(function(src, idx) {
                                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                        href: src,
                                                                        "data-fancybox": "mobile-gallery"
                                                                    }, idx + 11);
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: "hidden md:flex gap-3 items-stretch",
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "flex-1 w-0",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .Swiper */ .tq, {
                                                                    modules: [
                                                                        swiper__WEBPACK_IMPORTED_MODULE_5__/* .Autoplay */ .pt,
                                                                        swiper__WEBPACK_IMPORTED_MODULE_5__/* .Navigation */ .W_
                                                                    ],
                                                                    spaceBetween: 12,
                                                                    slidesPerView: 2.5,
                                                                    breakpoints: {
                                                                        768: {
                                                                            slidesPerView: 2.5
                                                                        },
                                                                        1024: {
                                                                            slidesPerView: 3.5
                                                                        },
                                                                        1280: {
                                                                            slidesPerView: 4.5
                                                                        }
                                                                    },
                                                                    navigation: false,
                                                                    autoplay: {
                                                                        delay: 3500,
                                                                        disableOnInteraction: false
                                                                    },
                                                                    className: "w-full !pb-2",
                                                                    children: galleryImages.slice(0, 10).map(function(src, idx) {
                                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(swiper_react__WEBPACK_IMPORTED_MODULE_4__/* .SwiperSlide */ .o5, {
                                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                                href: src,
                                                                                "data-fancybox": "mini-gallery",
                                                                                className: "w-full aspect-square rounded-xl overflow-hidden shadow-md group relative block cursor-zoom-in border border-gray-100 hover:border-brand-color-primary transition-colors",
                                                                                children: [
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                                        src: src,
                                                                                        alt: "Lujo Emo Villas - ".concat(idx + 1),
                                                                                        className: "w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                                                                                    }),
                                                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                                        className: "absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-500"
                                                                                    })
                                                                                ]
                                                                            })
                                                                        }, idx);
                                                                    })
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                className: "w-[28%] lg:w-[22%] xl:w-[18%] shrink-0 pb-2",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                                    href: galleryImages[10],
                                                                    "data-fancybox": "mini-gallery",
                                                                    className: "w-full h-full rounded-xl overflow-hidden shadow-md relative flex flex-col group cursor-pointer bg-slate-50 items-center justify-center border border-gray-200 hover:border-brand-color-primary transition-colors duration-300",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                            src: galleryImages[10],
                                                                            alt: "T\xfcm foto\u011Fraflar",
                                                                            className: "absolute inset-0 w-full h-full object-cover opacity-20 group-hover:opacity-10 transition-opacity duration-300"
                                                                        }),
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                                            className: "relative z-10 flex flex-col items-center justify-center text-center px-1",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                                                                                    className: "text-brand-color-primary font-bold text-lg md:text-xl mb-1",
                                                                                    children: [
                                                                                        "+",
                                                                                        galleryImages.length - 10
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                                    className: "text-gray-900 text-[9px] md:text-[10px] font-bold leading-tight uppercase",
                                                                                    children: "T\xfcm\xfcn\xfc G\xf6r"
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "hidden md:block",
                                                        children: galleryImages.slice(11).map(function(src, idx) {
                                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: src,
                                                                "data-fancybox": "mini-gallery",
                                                                className: "hidden"
                                                            }, idx + 11);
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full md:w-1/2",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "relative rounded-2xl overflow-hidden shadow-2xl h-full min-h-[300px] md:min-h-full bg-gray-900 group",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fancybox, {
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                href: "https://cdn.villavillam.com.tr/lujo-emo-villas/video.MP4",
                                                "data-fancybox": "promo-video",
                                                className: "absolute inset-0 w-full h-full block cursor-pointer",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                        src: videoPoster,
                                                        alt: "Lujo Emo Villas Tan\u0131t\u0131m",
                                                        className: "w-full h-full object-cover group-hover:scale-105 transition-transform duration-700"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute inset-0 bg-black/20 group-hover:bg-black/40 transition-colors duration-500"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute inset-0 flex items-center justify-center",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "w-20 h-20 bg-white/90 backdrop-blur-sm rounded-full flex items-center justify-center shadow-[0_10px_40px_rgba(0,0,0,0.3)] group-hover:scale-110 transition-transform duration-300",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                                                className: "w-8 h-8 text-brand-color-primary ml-1",
                                                                fill: "currentColor",
                                                                viewBox: "0 0 20 20",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                                                    d: "M4 4l12 6-12 6z"
                                                                })
                                                            })
                                                        })
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "pb-24 pt-12 px-6 max-w-5xl mx-auto",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex items-center gap-4 mb-10 justify-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-12 h-[1px] bg-brand-color-primary"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-xs font-bold text-brand-color-primary uppercase tracking-[0.3em] text-center",
                                        children: "\u0130lan Detaylar\u0131"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "w-12 h-[1px] bg-brand-color-primary"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "bg-white rounded-[2rem] p-8 md:p-12 shadow-[0_10px_40px_rgba(0,0,0,0.04)] border border-gray-100",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                    className: "grid grid-cols-1 md:grid-cols-2 gap-x-16 gap-y-2",
                                    children: [
                                        {
                                            label: "\u0130lan No",
                                            value: "LUJO-01"
                                        },
                                        {
                                            label: "Emlak Tipi",
                                            value: "Sat\u0131l\u0131k Villa"
                                        },
                                        {
                                            label: "Br\xfct m\xb2",
                                            value: "450"
                                        },
                                        {
                                            label: "Net m\xb2",
                                            value: "372"
                                        },
                                        {
                                            label: "Arsa Pay\u0131",
                                            value: "500 m\xb2"
                                        },
                                        {
                                            label: "Oda Say\u0131s\u0131",
                                            value: "4+1"
                                        },
                                        {
                                            label: "Banyo Say\u0131s\u0131",
                                            value: "5"
                                        },
                                        {
                                            label: "Bina Ya\u015F\u0131",
                                            value: "0 (Yeni)"
                                        },
                                        {
                                            label: "Is\u0131tma",
                                            value: "Yerden Is\u0131tma + VRF"
                                        },
                                        {
                                            label: "Krediye Uygun mu?",
                                            value: "Evet"
                                        },
                                        {
                                            label: "E\u015Fya Durumu",
                                            value: "Opsiyonel"
                                        }
                                    ].map(function(item, idx) {
                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                            className: "flex justify-between items-center py-4 border-b border-gray-100/70 hover:bg-slate-50/50 transition-colors px-3 rounded-xl -mx-3",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gray-500 font-medium text-sm md:text-base",
                                                    children: item.label
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "text-gray-900 font-bold text-sm md:text-base",
                                                    children: item.value
                                                })
                                            ]
                                        }, idx);
                                    })
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "py-24 px-6 max-w-6xl mx-auto bg-slate-50",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "text-center mb-16",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-3xl md:text-4xl font-bold text-gray-900 mb-4",
                                        children: "Kat Planlar\u0131"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-gray-500 max-w-2xl mx-auto",
                                        children: "Maksimum verimlilik ve konfor i\xe7in tasarlanm\u0131\u015F geni\u015F ya\u015Fam alanlar\u0131. \u0130lgili kat plan\u0131n\u0131 PDF olarak indirip inceleyebilirsiniz."
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "flex overflow-x-auto snap-x snap-mandatory md:grid md:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-6 pb-6 -mx-6 px-6 md:mx-0 md:px-0 md:pb-0 [&::-webkit-scrollbar]:hidden [-ms-overflow-style:none] [scrollbar-width:none]",
                                children: floorPlans.map(function(plan) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                        href: plan.url,
                                        target: "_blank",
                                        rel: "noopener noreferrer",
                                        className: "min-w-[150px] flex-shrink-0 snap-center group flex flex-col items-center justify-center p-6 bg-white rounded-3xl shadow-sm border border-gray-100 hover:shadow-xl hover:border-brand-color-primary/30 transition-all duration-300",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "w-16 h-16 rounded-full bg-brand-color-primary/5 text-brand-color-primary flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiFileText__WEBPACK_IMPORTED_MODULE_17__/* .FiFileText */ .N, {
                                                    size: 24
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: "text-gray-800 font-bold mb-2 text-center group-hover:text-brand-color-primary transition-colors",
                                                children: plan.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-sm text-gray-500 font-medium",
                                                children: "\u0130ncele & \u0130ndir"
                                            })
                                        ]
                                    }, plan.id);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        className: "relative py-32 overflow-hidden bg-slate-900",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute -top-[20%] -left-[10%] w-[50%] h-[50%] rounded-full bg-brand-color-primary/20 blur-[120px]"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute -bottom-[20%] -right-[10%] w-[40%] h-[60%] rounded-full bg-blue-500/10 blur-[100px]"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative z-10 max-w-7xl mx-auto px-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "mb-20 text-center",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: "text-brand-color-primary text-sm font-bold tracking-[0.3em] uppercase mb-4 block",
                                                children: "Ayr\u0131cal\u0131kl\u0131 Ya\u015Fam"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                                className: "text-4xl md:text-5xl font-light text-white mb-6",
                                                children: [
                                                    "Donan\u0131m ve ",
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                        className: "font-bold",
                                                        children: "\xd6zellikler"
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: "text-gray-400 max-w-2xl mx-auto text-lg leading-relaxed",
                                                children: "Her villada standart olarak sunulan premium \xf6zelliklerle, hayal etti\u011Finizden daha fazlas\u0131n\u0131 deneyimleyin."
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "grid grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-6",
                                        children: features.map(function(feature, idx) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "group relative flex flex-col items-center justify-start md:justify-center text-center p-3 md:p-8 rounded-2xl md:rounded-3xl bg-white/[0.03] backdrop-blur-xl border border-white/10 hover:bg-white/[0.08] hover:border-brand-color-primary/50 transition-all duration-500 hover:-translate-y-1 md:hover:-translate-y-2 cursor-default",
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "absolute inset-0 bg-gradient-to-br from-brand-color-primary/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 rounded-2xl md:rounded-3xl"
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "relative w-10 h-10 md:w-16 md:h-16 mb-3 md:mb-6 rounded-xl md:rounded-2xl bg-white/5 flex items-center justify-center text-brand-color-primary group-hover:scale-110 group-hover:bg-brand-color-primary group-hover:text-white transition-all duration-500 shadow-md md:shadow-lg group-hover:shadow-brand-color-primary/30",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiCheckCircle__WEBPACK_IMPORTED_MODULE_18__/* .FiCheckCircle */ ._, {
                                                            className: "w-5 h-5 md:w-7 md:h-7"
                                                        })
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                        className: "relative text-white/90 font-medium text-[11px] md:text-lg leading-tight md:leading-snug group-hover:text-white transition-colors",
                                                        children: feature
                                                    })
                                                ]
                                            }, idx);
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
                        className: "py-24 px-6 max-w-7xl mx-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "flex flex-col lg:flex-row gap-12 items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: "w-full lg:w-2/5",
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "text-brand-color-primary text-sm font-bold tracking-[0.3em] uppercase mb-4 block",
                                            children: "Konum"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                            className: "text-3xl md:text-5xl font-light text-gray-900 mb-6",
                                            children: [
                                                "M\xfckemmel ",
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                    className: "font-bold",
                                                    children: "Lokasyon"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                            className: "text-gray-600 mb-10 text-lg leading-relaxed",
                                            children: "Do\u011Fan\u0131n kalbinde, ancak \u015Fehrin olanaklar\u0131na bir o kadar yak\u0131n. \u0130htiya\xe7 duydu\u011Funuz her yere kolayca ula\u015F\u0131n."
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "space-y-3 md:space-y-4 p-0 m-0 w-full",
                                            children: [
                                                {
                                                    id: "fethiye",
                                                    name: "Fethiye Merkez",
                                                    time: "10 Dakika"
                                                },
                                                {
                                                    id: "oludeniz",
                                                    name: "\xd6l\xfcdeniz",
                                                    time: "5 Dakika"
                                                },
                                                {
                                                    id: "kayakoy",
                                                    name: "Kayak\xf6y",
                                                    time: "10 Dakika"
                                                },
                                                {
                                                    id: "dalaman",
                                                    name: "Dalaman Havaliman\u0131",
                                                    time: "60 Dakika"
                                                }
                                            ].map(function(loc) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                    onMouseEnter: function() {
                                                        return setHoveredLoc(loc.id);
                                                    },
                                                    onMouseLeave: function() {
                                                        return setHoveredLoc(null);
                                                    },
                                                    className: "flex items-center justify-between p-3 md:p-5 rounded-xl md:rounded-2xl border transition-all duration-300 cursor-pointer w-full ".concat(hoveredLoc === loc.id ? "bg-white shadow-xl border-brand-color-primary/30 scale-[1.02]" : "border-transparent hover:bg-white hover:shadow-md"),
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "flex items-center gap-3 md:gap-4 text-gray-800 font-medium text-sm md:text-lg",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "w-8 h-8 md:w-10 md:h-10 shrink-0 rounded-full flex items-center justify-center transition-all duration-300 ".concat(hoveredLoc === loc.id ? "bg-brand-color-primary text-white scale-110" : "bg-gray-100 text-gray-500"),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiMapPin__WEBPACK_IMPORTED_MODULE_19__/* .FiMapPin */ .i, {
                                                                        className: "w-4 h-4 md:w-5 md:h-5"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "truncate",
                                                                    children: loc.name
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                            className: "font-bold text-xs md:text-base whitespace-nowrap transition-colors duration-300 ".concat(hoveredLoc === loc.id ? "text-brand-color-primary" : "text-gray-500"),
                                                            children: loc.time
                                                        })
                                                    ]
                                                }, loc.id);
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "w-full lg:w-3/5",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "w-full h-[400px] md:h-[600px] bg-slate-100 rounded-[3rem] overflow-hidden relative shadow-2xl border-4 border-white group",
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("iframe", {
                                                ref: mapIframeRef,
                                                width: "100%",
                                                height: "100%",
                                                frameBorder: "0",
                                                scrolling: "no",
                                                marginHeight: "0",
                                                marginWidth: "0",
                                                src: "/map.html",
                                                className: "absolute inset-0 w-full h-full"
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "absolute inset-0 bg-gradient-to-tr from-brand-color-primary/5 via-transparent to-black/5 pointer-events-none"
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                        id: "iletisim",
                        className: "relative py-24 overflow-hidden",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "absolute inset-0 z-0",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                        src: ctaImage,
                                        alt: "Background",
                                        className: "w-full h-full object-cover blur-sm scale-110"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "absolute inset-0 bg-gray-900/80 backdrop-blur-md"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "relative z-10 max-w-4xl mx-auto px-6 text-center",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                        className: "text-3xl md:text-5xl font-bold text-white mb-6",
                                        children: "Yerinizi Almak \u0130\xe7in Ge\xe7 Kalmay\u0131n"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "text-gray-300 text-lg mb-12 max-w-2xl mx-auto",
                                        children: "Sadece 5 adet \xfcretilen Lujo Emo Villas projesi hakk\u0131nda detayl\u0131 bilgi, fiyat teklifi ve yerinde sunum i\xe7in bize ula\u015F\u0131n."
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "bg-white rounded-[2rem] p-8 md:p-12 shadow-2xl max-w-2xl mx-auto",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: "flex flex-col gap-6",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: "tel:+902526060505",
                                                    className: "flex items-center justify-center gap-4 w-full bg-brand-color-primary text-white font-bold py-5 px-6 rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-lg md:text-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiPhone__WEBPACK_IMPORTED_MODULE_20__/* .FiPhone */ .t, {
                                                            size: 28
                                                        }),
                                                        "+90 252 606 05 05"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: "https://wa.me/908503467049?text=Lujo%20Emo%20Villas%20projesi%20hakk%C4%B1nda%20bilgi%20almak%20istiyorum.",
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    className: "flex items-center justify-center gap-4 w-full bg-[#25D366] text-white font-bold py-5 px-6 rounded-2xl shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-lg md:text-xl",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fa_FaWhatsapp__WEBPACK_IMPORTED_MODULE_21__/* .FaWhatsapp */ .x, {
                                                            size: 32
                                                        }),
                                                        "WhatsApp'tan \u0130leti\u015Fime Ge\xe7"
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("a", {
                                                    href: "mailto:info@villavillam.com.tr",
                                                    className: "flex items-center justify-center gap-3 w-full bg-slate-50 text-gray-700 font-bold py-5 px-6 rounded-2xl hover:bg-slate-100 transition-colors duration-300 text-base md:text-lg mt-2 border border-slate-100",
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_react_icons_all_files_fi_FiMail__WEBPACK_IMPORTED_MODULE_22__/* .FiMail */ .I, {
                                                            size: 24,
                                                            className: "text-gray-400"
                                                        }),
                                                        "info@villavillam.com.tr"
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        dangerouslySetInnerHTML: {
                            __html: "\n          @keyframes scaleUp {\n            0% { transform: scale(1); }\n            100% { transform: scale(1.1); }\n          }\n          @keyframes fadeIn {\n            from { opacity: 0; transform: translateY(10px); }\n            to { opacity: 1; transform: translateY(0); }\n          }\n          .animate-fadeIn {\n            animation: fadeIn 0.5s ease-out forwards;\n          }\n        "
                        }
                    })
                ]
            })
        ]
    });
};


/***/ }),

/***/ 9846:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 92:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 68770:
/***/ (function() {

// extracted by mini-css-extract-plugin

/***/ }),

/***/ 20943:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _arrayLikeToArray; }
/* harmony export */ });
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}


/***/ }),

/***/ 13375:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _iterableToArray; }
/* harmony export */ });
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}


/***/ }),

/***/ 29815:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ _toConsumableArray; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_array_like_to_array.mjs
var _array_like_to_array = __webpack_require__(20943);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_array_without_holes.mjs


function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return (0,_array_like_to_array/* default */.Z)(arr);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_iterable_to_array.mjs
var _iterable_to_array = __webpack_require__(13375);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_non_iterable_spread.mjs
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_unsupported_iterable_to_array.mjs
var _unsupported_iterable_to_array = __webpack_require__(91566);
;// CONCATENATED MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs





function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || (0,_iterable_to_array/* default */.Z)(arr) || (0,_unsupported_iterable_to_array/* default */.Z)(arr) || _nonIterableSpread();
}


/***/ }),

/***/ 91566:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ _unsupportedIterableToArray; }
/* harmony export */ });
/* harmony import */ var _array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20943);


function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n))
    return (0,_array_like_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(o, minLen);
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [24366,50174,49774,92888,40179], function() { return __webpack_exec__(21360); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);